import * as React from "react";
import { cn } from "../../lib/utils";

interface ProgressProps {
  value: number;
  className?: string;
  indicatorClassName?: string;
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ value, className, indicatorClassName, ...props }, ref) => {
    // Asegurar que el valor esté entre 0 y 100
    const clampedValue = Math.min(Math.max(value, 0), 100);
    
    return (
      <div
        ref={ref}
        className={cn(
          "relative h-2 w-full overflow-hidden rounded-full bg-gray-200",
          className
        )}
        {...props}
      >
        <div
          className={cn(
            "h-full w-full flex-1 bg-macartur-primary transition-all duration-300 ease-in-out",
            indicatorClassName
          )}
          style={{
            transform: `translateX(-${100 - clampedValue}%)`
          }}
        />
      </div>
    );
  }
);

Progress.displayName = "Progress";

export { Progress };